// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root___sNDN","notes":"Notes_notes__37Ivy"};